import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18nify';
import EditModal from '../modal/EditModal';
import UrlLogging from '../../containers/advanced_filtering/UrlLogging';

const UrlLoggingModal = ({
  showModal,
  closeDialog,
  buttonAction,
  disabled,
}) => (
  <EditModal
    title={translate('components.advancedFiltering.fullUrlLogging')}
    showModal={showModal}
    buttonAction={buttonAction}
    closeDialog={closeDialog}
    saveBtnText={translate('shared.save')}
    disabled={disabled}
  >
    <UrlLogging />
  </EditModal>
);

UrlLoggingModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  buttonAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideNetwork: PropTypes.bool,
};

UrlLoggingModal.defaultProps = {
  disabled: false,
};

export default UrlLoggingModal;
